export const cpfMask = (value) =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');

export const formatCpf = (value) => {
  if (!value) return;
  const rawValue = value.replace(/\D/g, '');
  const formattedValue = rawValue.replace(
    /(\d{3})(\d{3})(\d{3})(\d{0,2})/,
    (match, p1, p2, p3, p4) => `${p1}.${p2}.${p3}-${p4}`.replace(/-$/, ''),
  );
  return formattedValue;
};
